import { Autocomplete, Box, Button, CircularProgress, FormControl, MenuItem, OutlinedInput, Select, TextField } from '@mui/material'
import React, { useContext, useEffect, useState } from 'react'
import Page from '../../component/Page'
// import KeyboardBackspaceIcon from '@mui/icons-material/KeyboardBackspace';
import { MobileDatePicker } from '@mui/x-date-pickers';
import api from '../../api/api'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowLeft, faMinusCircle, faPlusCircle } from '@fortawesome/free-solid-svg-icons';
import { useSelector } from 'react-redux';
import { GetBreedClassNo, GetSeasonNo, StockStatus } from './services/stockService';
import { useNavigate, useParams } from 'react-router-dom';
import StockContext from './services/stockApi';
import { getBranchList, getItemMasterList } from '../setting/services/settingApi';
import dayjs from 'dayjs';
import { STOCK_CONFIG } from './config';
import Swal from 'sweetalert2';
import ConfirmDialogTransfer from './component/confirmDialogTransfer';
import ConfirmPrint from './component/confirmPrint';
import { getData, postData, putData } from '../../services/api';
import './addStockTransfer.scss'
import useDebounce from '../../hook/useDebounce';

const BrowserInput = function BrowserInput(props) {
    const { inputProps, InputProps, ownerState, value, inputRef, error, ...other } = props;
    return (
        <TextField {...inputProps} ref={inputRef} value={value ? value.substring(0, value?.length - 6) + (parseInt(value?.substring(value?.length - 6)) + 543).toString() : null} {...other} variant="standard" fullWidth
            InputProps={{
                disableUnderline: true,
            }}
        />
    );
};
const CalQtySack = (option2, qty) => {
    let _qty = qty || 0;

    if (option2?.includes('หลัก')) {
        return Math.ceil(parseInt(_qty) / 20);
    } else {
        return Math.ceil(parseInt(_qty) / 25);
    }
}
export default function AddStockTransfer() {
    const { profile, loading } = useSelector(state => state.profile)
    const { id } = useParams()
    const navigate = useNavigate();
    // const { getZones, getLots, getTransferDetail } = useContext(StockContext);
    const [loadingPDF, setLoadingPDF] = useState(false);
    const [loadingSubmit, setLoadingSubmit] = useState(false);

    const [openP, setOpenP] = useState(false)
    const [documentDate, setDocumentDate] = useState(dayjs(new Date))
    const [transferFromDate, setTransferFromDate] = useState(dayjs(new Date))
    const [transferToDate, setTransferToDate] = useState(dayjs(new Date))
    const [branchs, setBranchs] = useState([])
    const [BranchNoTo, setBranchsNoTo] = useState('')
    const [BranchNoFrom, setBranchsNoFrom] = useState('')
    const [reason, setReason] = useState()
    const [reasonOther, setReasonOther] = useState()
    const [items, setItems] = useState([])
    const [lots, setLots] = useState([])
    const [lottext, setLottext] = useState('')
    const [lotnum, setLotnum] = useState('')
    const [zones, setZones] = useState([])
    const [newZones, setNewZones] = useState([])
    const [detail, setDetail] = useState()
    const [remark, setRemark] = useState('')
    const [open, setOpen] = useState(false)

    const [BranchToError, setBranchToError] = useState(false)
    const [reasonError, setReasonError] = useState(false)
    const [rows, setRows] = useState([
        {
            id: 0,
            ItemNo: null,
            Year: 0,
            Season: "",
            Lot: null,
            Qty: 0,
            UnitNo: "",
            ModifiedDate: null,
            FromWarehouseNo: "",
            FromZoneNo: "",
            WarehouseNo: "",
            ZoneNo: "",
            SalePrice: 0,
            CostPrice: 0,
            newValue: null
        }
    ]);
    function addRow() {
        const newRow = {
            id: rows?.slice(-1)[0]?.id ? rows?.slice(-1)[0]?.id + 1 : 1,
            ItemNo: null,
            Year: 0,
            Season: "",
            Lot: null,
            Qty: 0,
            UnitNo: "",
            ModifiedDate: null,
            FromWarehouseNo: "",
            FromZoneNo: "",
            WarehouseNo: "",
            ZoneNo: "",
            SalePrice: 0,
            CostPrice: 0,
            newValue: null
        };

        setRows([...rows, newRow]);
    }
    const deletehand = (i) => {
        const data = rows?.filter((e) => i !== e?.id);
        setRows(data);
    };

    const getZones = async (BranchNo) => {

        await getData(STOCK_CONFIG.requests.getZonesBranch.url + `/${BranchNo}/zones`).then((response) => {
            if (response.status === true) {
                setZones(response.result)
            }
        })
    }
    const getLots = async (BranchNo, keyword, lotNumber, sumLots, setData) => {
        let _params = '';
        let _name = '';
        let _lot = '';
        let _sumLots = '';

        if (keyword) {
            _name = 'name=' + keyword + '&';
        }
        if (lotNumber) {
            _lot = 'lot=' + lotNumber + '&';
        }
        if (sumLots) {
            _sumLots = 'sumLots=' + sumLots + '&';
        }

        _params = _name + _lot + _sumLots
        const url = STOCK_CONFIG.requests.getLotsBranch.url + `/${BranchNo}/lots`;

        await getData(url, '?' + _params + 'limit=200').then((response) => {
            if (response.status === true) {
                setData(response.result.items)
            }
        })
    }
    const getTransferDetail = async () => {

        const url = STOCK_CONFIG.requests.getTransfers.url + `/${id}`;

        await getData(url).then((response) => {
            if (response.status === true) {
                setDetail(response.result)
                getZones(response.result?.FromBranchNo?.BranchNo)
            }
        })
    }

    useEffect(() => {
        getBranchList(null, setBranchs)
    }, [])
    useEffect(() => {
        if (profile) {
            if (id) {
                getTransferDetail()
            } else {
                getZones(profile?.BranchNo?.BranchNo)
            }
            setBranchsNoFrom(profile?.BranchNo?.BranchNo)
        }
    }, [profile])


    useEffect(() => {

        getLots(BranchNoFrom ? BranchNoFrom : profile?.BranchNo?.BranchNo, null, null, null, setLots)

        setRows([
            {
                id: 0,
                ItemNo: null,
                Year: 0,
                Season: "",
                Lot: null,
                Qty: 0,
                UnitNo: "",
                ModifiedDate: null,
                FromWarehouseNo: "",
                FromZoneNo: "",
                WarehouseNo: "",
                ZoneNo: "",
                SalePrice: 0,
                CostPrice: 0,
                newValue: null
            }
        ])

    }, [BranchNoFrom])
    // useEffect(() => {
    //     getLots(BranchNoFrom ? BranchNoFrom : profile?.BranchNo?.BranchNo, debouncedSearchLot, null, null, setLots)

    // }, [BranchNoFrom, debouncedSearchLot])
    // useEffect(() => {
    //     getLots(BranchNoFrom ? BranchNoFrom : profile?.BranchNo?.BranchNo, debouncedSearchLot, null, null, setLots)
    //     if (debouncedSearchLotNum) {
    //         getLots(BranchNoFrom ? BranchNoFrom : profile?.BranchNo?.BranchNo, debouncedSearchLot, debouncedSearchLotNum, null, setItems)

    //     }

    // }, [BranchNoFrom, debouncedSearchLot, debouncedSearchLotNum])

    useEffect(() => {
        if (id) {
            const getNewZones = async () => {

                await getData(STOCK_CONFIG.requests.getZonesBranch.url + `/${detail?.ToBranchNo?.BranchNo}/zones`).then((response) => {
                    if (response.status === true) {
                        setNewZones(response.result)

                        const creds = detail?.TransferDetails.map((c) => {
                            const FromWarehouseNo = zones.find(x => x?.WarehouseNo?.WarehouseNo === c?.FromWarehouseNo)?.WarehouseNo
                            const FromZoneNo = zones.find(x => x.ZoneNo === c?.FromZoneNo)
                            return {
                                ...c,
                                ItemNo: c?.ItemNo,
                                GroupName: c?.ItemNo?.GroupNo,
                                Year: c?.Year,
                                Season: c?.Season,
                                Option1: c?.ItemNo?.Option1,
                                Option2: c?.ItemNo?.Option2,
                                UnitNo: c?.UnitNo?.UnitNo,
                                UnitName: c?.UnitNo?.UnitName,
                                Chemical: c?.ItemNo?.Chemical,
                                Lot: c?.Lot,
                                Qty: c.Qty.toLocaleString() || 0,
                                Balance: 0,
                                QtySack: null,
                                WarehouseNo: FromWarehouseNo,
                                ZoneNo: FromZoneNo,
                                SalePrice: c?.SalePrice,
                                CostPrice: c?.CostPrice,
                                WarehouseNoTo: response.result.find(x => x.ZoneNo === c?.ZoneNo?.ZoneNo),

                            }
                        });

                        setRows(creds)

                    }
                })
            }
            getNewZones()


            setDocumentDate(dayjs(detail?.DocumentDate))
            setTransferFromDate(dayjs(detail?.TransferFromDate))
            setTransferToDate(dayjs(detail?.TransferToDate))
            setBranchsNoFrom(detail?.FromBranchNo?.BranchNo)
            setBranchsNoTo(detail?.ToBranchNo?.BranchNo)
            setRemark(detail?.Remark)
            setReason(detail?.Reason)
            setReasonOther(detail?.ReasonOther)
            // const creds = detail?.TransferDetails.map((c) => {
            //     // const WarehouseTo = newZones.find(x => x.ZoneNo === c?.ZoneNo?.ZoneNo)
            //     const FromWarehouseNo = zones.find(x => x?.WarehouseNo?.WarehouseNo === c?.FromWarehouseNo)
            //     const FromZoneNo = zones.find(x => x.ZoneNo === c?.FromZoneNo)
            //     console.log(zones.find(x => x?.WarehouseNo?.WarehouseNo === c?.FromWarehouseNo))

            //     return {
            //         ItemNo: c?.ItemNo,
            //         GroupName: c?.ItemNo?.GroupNo,
            //         Year: c?.Year,
            //         Season: c?.Season,
            //         Option1: c?.ItemNo?.Option1,
            //         Option2: c?.ItemNo?.Option2,
            //         UnitNo: c?.UnitNo?.UnitNo,
            //         UnitName: c?.UnitNo?.UnitName,
            //         Chemical: c?.ItemNo?.Chemical,
            //         Lot: c?.Lot,
            //         Qty: c.Qty.toLocaleString() || 0,
            //         Balance: 0,
            //         QtySack: null,
            //         WarehouseNo: FromWarehouseNo,
            //         ZoneNo: FromZoneNo,
            //         // WarehouseNoTo: WarehouseTo,
            //         SalePrice: c?.SalePrice,
            //         CostPrice: c?.CostPrice,
            //     }



            // });

            // setRows(creds)


        }

    }, [detail])

    const handleSubmit = (e) => {

        const body = {
            TransferNo: id || null,
            DocumentDate: dayjs(documentDate).format('YYYY-MM-DD'),
            FromBranchNo: BranchNoFrom,
            TransferFromDate: dayjs(transferFromDate).format('YYYY-MM-DD'),
            ToBranchNo: BranchNoTo,
            TransferToDate: dayjs(transferToDate).format('YYYY-MM-DD'),
            Reason: reason,
            ReasonOther: reasonOther,
            TransferDetails: rows?.map((x) => (
                {
                    ...x,
                    ItemNo: x?.ItemNo?.ItemNo,
                    Year: x?.Year,
                    Season: x?.ItemNo?.Season,
                    Lot: x?.Lot?.Lot,
                    Qty: +x?.Qty.toString().replaceAll(',', ''),
                    UnitNo: x?.UnitNo?.UnitNo,
                    FromWarehouseNo: x?.WarehouseNo?.WarehouseNo,
                    FromZoneNo: x?.ZoneNo?.ZoneNo,
                    ModifiedDate: dayjs(new Date()).format('YYYY-MM-DD'),
                    WarehouseNo: x?.WarehouseNoTo?.WarehouseNo?.WarehouseNo,
                    ZoneNo: x?.WarehouseNoTo?.ZoneNo,
                    SalePrice: x?.Lot?.SalePrice,
                    CostPrice: x?.CostPrice
                }
            )),
            Status: e,
        }
        const transferAdd = async () => {
            setLoadingSubmit(true)
            if (body?.TransferNo) {
                const url = STOCK_CONFIG.requests.getTransfers.url + `/${body?.TransferNo}`;
                await putData(url, body).then((response) => {
                    if (response.status === true) {
                        if (body.Status === 'N') {
                            Swal.fire(
                                'ยกเลิกรายการสำเร็จ',
                                '',
                                'success'
                            )
                            navigate('/stock/stock-transfer/' + response.result.TransferNo)
                            setOpen(false)
                            setLoadingSubmit(false)
                            getTransferDetail()
                        } else {
                            navigate('/stock/stock-transfer/' + response.result.TransferNo)
                            setOpenP(true)
                            setOpen(false)
                            setLoadingSubmit(false)
                        }

                    } else {
                        Swal.fire({
                            title: response?.message || 'ทำรายการไม่สำเร็จ',
                            icon: 'warning',
                        })
                        setLoadingSubmit(false)
                    }
                })

            } else {
                postData(STOCK_CONFIG.requests.getTransfers.url, body).then((response) => {
                    if (response.status === true) {
                        navigate('/stock/stock-transfer/' + response.result.TransferNo)
                        setOpenP(true)
                        setOpen(false)
                        setLoadingSubmit(false)
                    } else {
                        Swal.fire({
                            title: response?.message || 'ทำรายการไม่สำเร็จ',
                            icon: 'warning',
                        })
                        setLoadingSubmit(false)
                    }
                })
            }
        }
        if (e === 'N') {
            Swal.fire({
                title: 'ยืนยันการยกเลิก',
                icon: 'warning',
                showCancelButton: true,
                confirmButtonColor: '#4ab866',
                cancelButtonColor: '#d33',
            }).then((result) => {
                if (result.isConfirmed) {
                    transferAdd()
                }
            })
        } else {
            transferAdd()
        }
    }

    async function downloadTransfers() {
        setLoadingPDF(true)
        const res = await api.get(STOCK_CONFIG.requests.getTransfers.url + `/${id}/pdf`, {
            responseType: 'arraybuffer'
        })
        const buffer = res.data
        const blob = new Blob([buffer], { type: 'application/pdf' });
        const url = window.URL.createObjectURL(blob);
        window.open(url, '_blank');
        setLoadingPDF(false)
    }

    return (
        <div style={{ padding: '10px 30px' }}>
            <Page>
                <div class="container-fluid">
                    <div class="d-flex row align-items-center ">
                        <div class="col-6">
                            <label class="title-content mb-4">
                                ข้อมูลโอนเมล็ดพันธุ์ระหว่างศูนย์
                            </label>
                        </div>
                        {id &&
                            <div class="col-6 text-end px-4">
                                <Button variant='contained' className="ButtomSearch" sx={{
                                    width: '110px',
                                    background: '#3364af57 0 0 no-repeat padding-box',
                                    border: '1px solid #3364af57',
                                    color: '#3364af',
                                    fontWeight: '700',
                                    borderRadius: '100px', ':hover': {
                                        background: '#3364af57 0 0 no-repeat padding-box',
                                    }
                                }} onClick={downloadTransfers}>{loadingPDF ? <CircularProgress size={'18px'} color="inherit" /> : 'พิมพ์'}</Button>
                            </div>}
                    </div>
                    <div class="row">
                        <div class="col-lg-4 col-md-6">
                            <label class="labelInput">เลขที่เอกสาร</label>
                            <Box className='backgroundField' sx={{ marginBottom: '10px' }}>
                                <TextField disabled value={detail?.TransferNo} variant="standard" fullWidth
                                    InputProps={{
                                        disableUnderline: true,
                                    }}
                                />
                            </Box>
                        </div>
                        <div class="col-lg-4 col-md-6">
                            <label class="labelInput">วันที่เอกสาร</label>
                            <Box className='backgroundField' sx={{ marginBottom: '10px' }}>
                                <MobileDatePicker
                                    disabled={id ? true : false}
                                    dayOfWeekFormatter={(day) => `${day}`}
                                    value={documentDate} onChange={e => setDocumentDate(e)}
                                    slotProps={{ textField: { variant: 'standard', fullWidth: true, InputProps: { disableUnderline: true }, value: documentDate } }}
                                    slots={{
                                        textField: BrowserInput,
                                    }}
                                />

                            </Box>

                        </div>
                    </div>
                    {id &&
                        <div class="row">
                            <div class="col-lg-4 col-md-6">
                                <label class="labelInput me-3">ผู้สร้าง</label> <label class="message-error-label">( {dayjs(detail?.CreateDate).format('DD/MM/BBBB')} )</label>
                                <Box className='backgroundField' sx={{ marginBottom: '10px' }}>
                                    <TextField value={detail?.CreateId} variant="standard" fullWidth disabled={id ? true : false}

                                        InputProps={{
                                            disableUnderline: true,
                                        }}
                                    />
                                </Box>
                            </div>
                            <div class="col-lg-4 col-md-6">
                                <label class="labelInput me-3">ผู้แก้ไข</label> <label class="message-error-label">( {dayjs(detail?.ModifiedDate).format('DD/MM/BBBB')} )</label>
                                <Box className='backgroundField' sx={{ marginBottom: '10px' }}>
                                    <TextField value={detail?.ModifiedId} variant="standard" fullWidth disabled={id ? true : false}
                                        InputProps={{
                                            disableUnderline: true,
                                        }}
                                    />
                                </Box>
                            </div>
                        </div>
                    }
                    <div class="row">
                        <div class="col-lg-4 col-md-6">
                            <label class="labelInput">วันที่จ่ายออก</label>
                            <Box className='backgroundField' sx={{ marginBottom: '10px' }}>
                                <MobileDatePicker
                                    disabled={id ? true : false}
                                    dayOfWeekFormatter={(day) => `${day}`}
                                    value={transferFromDate} onChange={e => setBranchsNoFrom(e)}
                                    slotProps={{ textField: { variant: 'standard', fullWidth: true, InputProps: { disableUnderline: true }, value: transferFromDate } }}
                                    slots={{
                                        textField: BrowserInput,
                                    }}
                                />

                            </Box>
                        </div>
                        <div class="col-lg-4 col-md-6">
                            <label class="labelInput">จ่ายออก</label>
                            <Box className='backgroundField' sx={{ marginBottom: '10px' }}>
                                <FormControl variant="standard" fullWidth disabled={id ? true : false}>
                                    <Select value={BranchNoFrom || ''} onChange={e => {
                                        setBranchsNoFrom(e.target.value)
                                        setRows([])
                                        setLottext('')
                                        setLotnum('')
                                    }} disableUnderline >
                                        {branchs?.map((x) => (
                                            <MenuItem value={x?.BranchNo}>{x?.BranchName}</MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                            </Box>
                        </div>

                    </div>
                    <div class="row">
                        <div class="col-lg-4 col-md-6">
                            <label class="labelInput">วันที่รับเข้า</label>
                            <Box className='backgroundField' sx={{ marginBottom: '10px' }}>
                                <MobileDatePicker
                                    disabled={id ? true : false}
                                    dayOfWeekFormatter={(day) => `${day}`}
                                    value={transferToDate} onChange={e => setTransferToDate(e)}
                                    slotProps={{ textField: { variant: 'standard', fullWidth: true, InputProps: { disableUnderline: true }, value: transferToDate } }}
                                    slots={{
                                        textField: BrowserInput,
                                    }}
                                />
                            </Box>
                        </div>
                        <div class="col-lg-4 col-md-6">
                            <label class="labelInput">รับเข้า</label>
                            <Box className={`backgroundField ${BranchToError ? 'error' : ''}`}>
                                <FormControl variant="standard" fullWidth disabled={id ? true : false}>
                                    <Select value={BranchNoTo || ''} onChange={e => {
                                        setBranchsNoTo(e.target.value)
                                        const getNewZones = async () => {

                                            await getData(STOCK_CONFIG.requests.getZonesBranch.url + `/${e.target.value}/zones`).then((response) => {
                                                if (response.status === true) {
                                                    setNewZones(response.result)
                                                    const item = rows?.map((v, index) => {
                                                        v.WarehouseNoTo = response.result[0]

                                                        return v;

                                                    });
                                                    setRows([...item]);
                                                }
                                            })
                                        }
                                        getNewZones()
                                    }} onBlur={e => {
                                        if (!e.target.value) {
                                            setBranchToError(true)
                                        } else {
                                            setBranchToError(false)
                                        }
                                    }} disableUnderline >
                                        {branchs?.map((x) => (
                                            <MenuItem value={x?.BranchNo}>{x?.BranchName}</MenuItem>
                                        ))}
                                    </Select>
                                </FormControl>
                            </Box>
                            {BranchToError && <span style={{ color: 'red', fontSize: '12px', }}>กรุณาเลือกเหตุผล</span>}

                        </div>
                    </div>
                    <div class="row">
                        <div class="col-lg-4 col-md-6">
                            <label class="labelInput">เหตุผล</label>
                            <Box className={`backgroundField ${reasonError ? 'error' : ''}`} >
                                <FormControl variant="standard" fullWidth disabled={id ? true : false}>
                                    <Select value={reason || ''} onChange={e => setReason(e.target.value)} disableUnderline onBlur={e => {
                                        if (!e.target.value) {
                                            setReasonError(true)
                                        } else {
                                            setReasonError(false)
                                        }
                                    }} >

                                        <MenuItem value='จัดทำแปลง'>จัดทำแปลง</MenuItem>
                                        <MenuItem value='จำหน่าย'>จำหน่าย</MenuItem>
                                        <MenuItem value='อื่นๆ'>อื่นๆ</MenuItem>
                                    </Select>
                                </FormControl>
                            </Box>
                            {reasonError && <span style={{ color: 'red', fontSize: '12px', }}>กรุณาเลือกเหตุผล</span>}

                        </div>
                        {reason === 'อื่นๆ' &&
                            <div class="col-lg-4 col-md-6">
                                <label class="labelInput">เหตุผลอื่นๆ</label>
                                <Box className='backgroundField' sx={{ marginBottom: '10px' }}>
                                    <TextField value={reasonOther} onChange={e => setReasonOther(e.target.value)} variant="standard" fullWidth disabled={id ? true : false}
                                        InputProps={{
                                            disableUnderline: true,
                                        }}
                                    />
                                </Box>
                            </div>
                        }
                    </div>


                    <div class="d-flex row align-items-center mt-5 mb-4">
                        <div class="col-6">
                            <label class="title-content">
                                รายการโอนเมล็ดพันธุ์
                            </label>
                        </div>
                        {!id && <div class="col-6 text-end">
                            <FontAwesomeIcon icon={faPlusCircle} onClick={addRow} />
                        </div>}
                    </div>
                    <div class="addStockTransfer row">
                        <div class="col-md-12 table-responsive-sm " style={{ height: 'auto' }}>
                            <table class="table table-borderless  ">
                                <thead>
                                    <tr>
                                        <th class="text-center">ที่</th>
                                        <th class="text-center" style={{ width: '200px' }}>เมล็ดพันธุ์</th>
                                        <th class="text-center">ชั้นพันธุ์</th>

                                        <th class="text-center">ฤดู</th>
                                        <th class="text-center">ชนิดข้าว</th>
                                        <th class="text-center">สารเคมี</th>
                                        <th class="text-center"> ปีที่ผลิต</th>

                                        <th class="text-center" style={{ width: '160px' }}>ล็อตที่</th>
                                        <th class="text-center">จำนวน (กระสอบ)</th>
                                        <th class="text-center" style={{ width: '180px' }}>ปริมาณ</th>
                                        {id ? null : <th class="text-center">ยอดคงเหลือ</th>}
                                        <th class="text-center">หน่วย</th>
                                        <th class="text-center">โรงเก็บ</th>
                                        <th class="text-center">ราคาจำหน่าย</th>
                                        <th class="text-center">ต้นทุนการผลิต</th>
                                        <th class="text-center">โรงเก็บที่รับเข้า</th>
                                        {!id && <th ></th>}
                                    </tr>
                                </thead>
                                <tbody class="">
                                    {rows?.map((x, i) => (
                                        <tr >
                                            <td>{i + 1}.</td>
                                            <td style={{ position: 'relative' }}> {id ? <TextField sx={{ background: id ? '#e9ecef' : '#fff' }} InputProps={{
                                                readOnly: id ? true : false
                                            }}
                                                value={x?.ItemNo?.ItemName} size='small' fullWidth variant='outlined' /> : <Autocomplete
                                                freeSolo
                                                size='small'
                                                options={lots}
                                                getOptionLabel={(option) => option?.ItemNo?.ItemName}
                                                onBlur={e => {
                                                    const item = rows?.map((v, index) => {
                                                        v.ItemError = index === i ? x.ItemNo ? false : true : v?.ItemError;
                                                        return v;

                                                    });
                                                    setRows([...item]);
                                                }
                                                }
                                                componentsProps={{
                                                    paper: {
                                                        sx: {
                                                            width: 500
                                                        }
                                                    }
                                                }}
                                                renderOption={(props, option) => (
                                                    <Box component="li" {...props} key={option.ItemNo.ItemNo}>
                                                        {option?.ItemNo?.CatalogNo?.CatalogName} {option?.ItemNo?.Option2} <span style={{ color: option?.ItemNo?.Season === 'ฝน' ? '#0D9206' : 'brown', fontWeight: 'bold', margin: '0 10px' }}>{option?.Season}</span> {option?.ItemNo?.Option1} {option?.ItemNo?.Chemical}
                                                    </Box>
                                                )}
                                                // inputValue={lottext || ''}
                                                // onInputChange={(event, newInputValue) => {
                                                //     setLottext(newInputValue)
                                                // }}
                                                value={x?.Lot || null}
                                                onChange={(event, newValue) => {
                                                    const branchNo = profile?.BranchNo?.BranchNo
                                                    const breedClassNo = GetBreedClassNo(x?.Option2)
                                                    const seasonNo = GetSeasonNo(x?.Season)
                                                    const lotNumber = branchNo + breedClassNo + seasonNo + x?.Year;
                                                    const item = rows?.map((v, index) => {
                                                        // v.ItemNo = v?.id === x?.id ? newValue?.ItemNo?.ItemNo : v?.ItemNo;
                                                        // v.Option1 = v?.id === x?.id ? newValue?.ItemNo?.Option1 : v?.Option1;
                                                        // v.Option2 = v?.id === x?.id ? newValue?.ItemNo?.Option2 : v?.Option2;
                                                        // v.Season = v?.id === x?.id ? newValue?.ItemNo?.Season : v?.Season;
                                                        // v.Chemical = v?.id === x?.id ? newValue?.ItemNo?.Chemical : v?.Chemical;
                                                        // v.Year = v?.id === x?.id ? newValue?.Year : v?.Year;
                                                        // v.ModifiedDate = v?.id === x?.id ? newValue?.ItemNo?.ModifiedDate : v?.ModifiedDate;
                                                        // v.SalePrice = v?.id === x?.id ? newValue?.ItemNo?.SalePrice : v?.SalePrice;
                                                        // v.CostPrice = v?.id === x?.id ? newValue?.CostPrice : v?.CostPrice;
                                                        // v.Lot = i === index ? newValue : v?.Lot;
                                                        // v.LotGen = i === index ? lotNumber : v?.LotGen;
                                                        v.ItemNo = i === index ? newValue.ItemNo : v?.ItemNo;
                                                        v.UnitNo = i === index ? newValue.UnitNo : v?.UnitNo;
                                                        return v;

                                                    });
                                                    setRows([...item]);
                                                    // getItemsLot(newValue?.ItemNo?.ItemNo)
                                                    getLots(BranchNoFrom, newValue?.ItemNo?.ItemNo, null, null, setItems)

                                                }}

                                                renderInput={(params) => (
                                                    <Box ref={params.InputProps.ref}>
                                                        <OutlinedInput error={!x?.ItemError ? false : true} {...params.inputProps} fullWidth size='small' sx={{ padding: '0 !important', background: id ? '#e9ecef' : '#fff' }} />
                                                    </Box>
                                                )}
                                            />}
                                                {!x?.ItemError ? '' : <span style={{ color: 'red', fontSize: '12px', position: 'absolute' }}>กรุณาเลือกเมล็ดพันธุ์</span>}

                                            </td>
                                            <td class="text-center">{x?.ItemNo?.Option2}</td>
                                            <td class="text-center" style={{ color: x?.ItemNo?.Season === 'ฝน' ? '#0D9206' : 'brown', fontWeight: 'bold' }}>{x?.ItemNo?.Season}
                                            </td>
                                            <td class="text-center">{x?.ItemNo?.Option1}</td>
                                            <td class="text-center">{x?.ItemNo?.Chemical}</td>
                                            <td class="text-center">{x?.Year}</td>

                                            <td style={{ position: 'relative' }}>
                                                {id ? <TextField sx={{ background: id ? '#e9ecef' : '#fff' }} InputProps={{
                                                    readOnly: id ? true : false
                                                }}
                                                    value={x?.Lot?.Lot || x?.Lot} size='small' fullWidth variant='outlined' /> : <Autocomplete
                                                    freeSolo
                                                    size='small'
                                                    options={items}
                                                    getOptionLabel={(option) => option?.Lot}
                                                    renderOption={(props, option) => (
                                                        <Box component="li" {...props} key={option.Lot}>
                                                            Lot: {option?.Lot} / {option?.WarehouseNo?.WarehouseName}
                                                        </Box>
                                                    )}
                                                    onBlur={e => {
                                                        const item = rows?.map((v, index) => {
                                                            v.LotError = index === i ? x.Lot ? false : true : v?.LotError;
                                                            return v;

                                                        });
                                                        setRows([...item]);
                                                    }
                                                    }
                                                    componentsProps={{
                                                        paper: {
                                                            sx: {
                                                                width: 300
                                                            }
                                                        }
                                                    }}
                                                    onKeyPress={(event) => {
                                                        if (!/[0-9]/.test(event.key)) {
                                                            event.preventDefault();
                                                        }
                                                    }}
                                                    // inputValue={lotnum || ''}
                                                    // onInputChange={(event, newInputValue) => {
                                                    //     setLotnum(newInputValue)
                                                    // }}
                                                    onChange={(event, newValue) => {
                                                        const item = rows?.map((v, index) => {
                                                            v.Balance = i === index ? newValue?.Balance : v?.Balance;
                                                            v.Qty = i === index ? newValue?.Qty || 0 : v?.Qty;
                                                            v.CostPrice = i === index ? newValue?.CostPrice || 0 : v?.CostPrice;
                                                            v.WarehouseNo = i === index ? newValue?.WarehouseNo : v?.WarehouseNo;
                                                            v.ZoneNo = i === index ? newValue?.ZoneNo : v?.ZoneNo;
                                                            // v.FromWarehouseNo = i === index ? newValue?.WarehouseNo?.WarehouseNo : v?.FromWarehouseNo;
                                                            // v.FromZoneNo = i === index ? newValue?.ZoneNo?.ZoneNo : v?.FromZoneNo;
                                                            v.Year = i === index ? newValue?.Year : v?.Year;
                                                            v.Lot = i === index ? newValue : v?.Lot;


                                                            return v;
                                                        });
                                                        setRows([...item]);
                                                    }}
                                                    renderInput={(params) => (
                                                        <Box ref={params.InputProps.ref}>
                                                            <OutlinedInput error={!x?.LotError ? false : true}  {...params.inputProps} fullWidth size='small' sx={{ padding: '0 !important' }} />
                                                        </Box>)}
                                                />}
                                                {!x?.LotError ? '' : <span style={{ color: 'red', fontSize: '12px', position: 'absolute' }}>กรุณาเลือกล็อต</span>}

                                            </td>
                                            <td class="text-center">
                                                {CalQtySack(x.Option2, +x.Qty?.toString().replaceAll(',', '')).toLocaleString()}
                                            </td>
                                            <td class="text-center" style={{ position: 'relative' }}>
                                                <TextField sx={{ background: id ? '#e9ecef' : '#fff' }} InputProps={{
                                                    readOnly: id ? true : false,

                                                }} value={x?.Qty?.toLocaleString()} type='tel' size='small' fullWidth variant='outlined' onChange={e => {
                                                    const item = rows?.map((v, index) => {
                                                        let newValue = e.target.value.replace(/,/g, "");

                                                        let abc = newValue.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
                                                        v.Qty = i === index ? abc : v?.Qty;
                                                        return v;

                                                    });
                                                    setRows([...item]);
                                                }}
                                                    onKeyPress={(event) => {
                                                        if (!/[0-9]/.test(event.key)) {
                                                            event.preventDefault();
                                                        }
                                                    }}
                                                    onBlur={e => {
                                                        if (!id) {
                                                            const item = rows?.map((v, index) => {
                                                                v.QtyError = index === i ? +x?.Qty?.toString().replaceAll(',', '') > +x?.Balance?.toString().replaceAll(',', '') : v?.QtyError;
                                                                return v;

                                                            });
                                                            setRows([...item]);
                                                        }
                                                    }
                                                    }
                                                // error={!id && +x?.Qty?.toString().replaceAll(',', '') > +x?.Balance?.toString().replaceAll(',', '')}
                                                />
                                                {!x?.QtyError ? '' : <span style={{ color: 'red', fontSize: '12px', position: 'absolute', bottom: '-6px', left: '10px' }}>กรุณาระบุปริมาณให้ถูกต้อง</span>}

                                            </td>
                                            {id ? '' : <td class="text-center">{(x?.Balance || 0).toLocaleString()}</td>}
                                            <td>
                                                {x?.UnitNo?.UnitName || x?.UnitName}
                                            </td>
                                            <td class="text-center">
                                                <TextField sx={{ background: id ? '#e9ecef' : '#fff' || x?.WarehouseNo?.WarehouseName && x?.ZoneNo?.ZoneName ? '#e9ecef' : '#fff' }} InputProps={{
                                                    readOnly: id ? true : false
                                                }} value={x?.WarehouseNo?.WarehouseName && x?.ZoneNo?.ZoneName ? `${x?.WarehouseNo?.WarehouseName} / ${x?.ZoneNo?.ZoneName}` : ''} size='small' fullWidth variant='outlined' />

                                            </td>
                                            <td class="text-center">
                                                {parseFloat(x?.Lot?.SalePrice || x?.SalePrice).toFixed(2)
                                                    .replace(/\d(?=(\d{3})+\.)/g, "$&,")}
                                            </td>
                                            <td class="text-center">
                                                {parseFloat(x?.CostPrice || x?.Lot?.CostPrice || 0).toFixed(2)
                                                    .replace(/\d(?=(\d{3})+\.)/g, "$&,")}
                                            </td>
                                            <td class="text-center" style={{ position: 'relative' }}>
                                                <FormControl className='w-120' variant="outlined" size='small' fullWidth sx={{ background: id ? '#e9ecef' : '#fff' }}>
                                                    <Select disabled={id ? true : false} value={x?.WarehouseNoTo?.ZoneNo || 'all'} onChange={e => {
                                                        const item = rows?.map((v, index) => {
                                                            // v.WarehouseNo = i === index ? e.target.value === 'all' ? '' : e.target.value : v?.WarehouseNo;
                                                            v.ZoneNoTo = i === index ? newZones?.find((x) => x?.ZoneNo === e.target.value).ZoneNo : v?.ZoneNo
                                                            v.WarehouseNoTo = i === index ? newZones?.find((x) => x?.ZoneNo === e.target.value) : v?.WarehouseNoTo
                                                            return v;

                                                        });
                                                        setRows([...item]);
                                                    }}
                                                        onBlur={e => {
                                                            const item = rows?.map((v, index) => {
                                                                v.WarehouseError = index === i ? x.WarehouseNo ? false : true : v?.WarehouseError;
                                                                return v;

                                                            });
                                                            setRows([...item]);

                                                        }}>
                                                        <MenuItem value='all' disabled>เลือกโรงเก็บ</MenuItem>
                                                        {newZones && newZones?.map((z, i) => (
                                                            <MenuItem value={z?.ZoneNo}>{z?.WarehouseNo?.WarehouseName} {z?.ZoneName}</MenuItem>
                                                        ))}
                                                    </Select>
                                                </FormControl>
                                                {!x?.WarehouseError ? '' : <span style={{ color: 'red', fontSize: '12px', position: 'absolute', bottom: '-6px', left: "8px" }}>กรุณาเลือกโรงเก็บ</span>}

                                            </td>

                                            {!id && <td><FontAwesomeIcon icon={faMinusCircle} onClick={() => deletehand(i)} /></td>}

                                        </tr>
                                    ))}

                                </tbody>
                            </table>
                        </div>


                    </div>
                    <hr class="chr" />
                    <div class="row mt-4">

                        <div class="col-12">
                            <div class="col-12">
                                <Button onClick={() => navigate(-1)} variant='outlined'
                                    startIcon={<FontAwesomeIcon icon={faArrowLeft} />}
                                    sx={{ width: '130px', fontSize: '14px', marginRight: '10px' }}>กลับ</Button>
                                {detail && (detail?.Status !== StockStatus.Inactive && detail?.Cancelable) && <Button variant='contained' color='error' sx={{ width: '130px', fontSize: '14px' }} onClick={() => handleSubmit(StockStatus.Inactive)}>ยกเลิก</Button>}
                                {!id && <Button variant='contained' sx={{ width: '130px', fontSize: '14px' }} onClick={() => {
                                    if (!BranchNoTo) {
                                        setBranchToError(true)
                                    }
                                    if (!reason) {
                                        setReasonError(true)
                                    }
                                    if (rows?.filter((x) => !x?.ItemNo)) {
                                        const item = rows?.map((v, index) => {
                                            v.ItemError = v.ItemNo ? false : true
                                            return v;

                                        });
                                        setRows([...item]);
                                    }
                                    if (rows?.filter((x) => x?.Lot?.length < 1)) {
                                        const item = rows?.map((v, index) => {
                                            v.LotError = v?.Lot?.Lot?.length >= 1 ? false : true
                                            return v;

                                        });
                                        setRows([...item]);
                                    }

                                    if (rows?.filter((x) => !x?.WarehouseNoTo)?.length > 0) {
                                        const item = rows?.map((v, index) => {
                                            v.WarehouseError = v.WarehouseNoTo ? false : true
                                            return v;

                                        });
                                        setRows([...item]);
                                    }
                                    if (rows?.filter((x) => +x?.Qty?.toString().replaceAll(',', '') > +x?.Balance?.toString().replaceAll(',', ''))) {
                                        const item = rows?.map((v, index) => {
                                            v.QtyError = +v?.Qty?.toString().replaceAll(',', '') <= +v?.Balance?.toString().replaceAll(',', '') ? false : true
                                            return v;

                                        });
                                        setRows([...item]);
                                    }
                                    if (BranchNoTo && reason && rows?.filter((x) => !x?.ItemNo).length === 0 && rows?.filter((x) => x?.Lot?.length < 1).length === 0 && rows?.filter((x) => !x?.WarehouseNoTo).length === 0 && rows?.filter((x) => +x?.Qty?.toString().replaceAll(',', '') > +x?.Balance?.toString().replaceAll(',', '')).length === 0) {
                                        setOpen(true)
                                    }

                                }}>บันทึก</Button>}
                            </div>

                        </div>
                    </div>
                </div>
            </Page>
            <ConfirmDialogTransfer open={open} setOpen={setOpen} rows={rows} handleAdd={handleSubmit} loadingSubmit={loadingSubmit} />
            <ConfirmPrint title={'บันทึกรายการโอนเมล็ดพันธุ์สำเร็จ'} download={downloadTransfers} open={openP} setOpen={setOpenP} loadingPDF={loadingPDF} linkTo='/stock/stock-transfer/add' />

        </div>
    )
}
